import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity'
import Headline from 'components/atoms/headline/Headline'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle'
import Table from 'components/molecules/table/Table'
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout'
import { orderRequestsAdminHeaders } from 'lib/helpers/constants/columns/orderRequestsAdminHeaders'
import { usePendingOrderRequests } from 'lib/hooks/queries/Employee/usePendingOrderRequests'
import React from 'react'

const EmployeeOrdersView = () => {

  const { data, isLoading } = usePendingOrderRequests()

  return (
    <div>
      <Headline title='Orders' />
      <DashboardBoxLayout>
        <div className="mb-5">

          <DashboardBoxTitle title='Manage Orders' />
        </div>
        
        <div>
          {isLoading ? (
            <div className='relative py-20'>
              <LoadingScreen />
            </div>
          ) : (
            (data as any)?.data?.length === 0 ? (
              <EmptyEntity
                name='Orders'
              />
            ) : (
              <Table
                columns={orderRequestsAdminHeaders}
                data={(data as any)?.data}
                search=''
              />
            )
          )}
        </div>
      </DashboardBoxLayout>
    </div>
  )
}

export default EmployeeOrdersView